export const STORAGE_KEY = 'payments-new-donation-form-submitted'

export function restoreDonationFormEditState({ event, navigationType, storage, location }) {
  if (!event.persisted && navigationType !== 'back_forward') {
    storage.removeItem(STORAGE_KEY)
    return
  }

  if (storage.getItem(STORAGE_KEY) !== 'true') return

  storage.removeItem(STORAGE_KEY)
  const url = new URL(location.href)
  url.searchParams.set('edit_selection', 'true')
  location.replace(url.toString())
}
